<!--
 * @Description: 地图
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-06 15:45:44
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 17:17:55
 -->
<template>
  <div class="mapContent">
    <div class="ChinaMap">
      <dv-flyline-chart-enhanced :dev="true" :config="mapConfig" style="width:100%;height:100%;" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'mapContent',
  components: {
  },
  data () {
    return {
      mapConfig: {},
    }
  },
  methods: {
    /**
     * @description                   获取地图数据
     * @return {undefied}             无返回值
     */
    getDeployMapData () {
      this.$http.get('/rest/screen/project/list', {
        productCode: 'lwtsgz',
      }).then(res => {
        if (res.code === 0) {
          let points = [
            {
              name: '河南省',
              coordinate: [0.65, 0.45],
              icon: {
                src: '/static/img/layout/mapCenterPoint.png',
                width: 30,
                height: 30,
              },
              halo: {
                show: true,
              },
              text: {
                color: '#00ffee',
              },
            },
          ]
          let lines = []
          res.data.map(item => {
            if (item.provincePosition) {
              if (item.provincePosition) {
                points.push({
                  name: item.provinceName,
                  coordinate: [parseFloat(item.provincePosition.split(',')[0]), parseFloat(item.provincePosition.split(',')[1])],
                })
                lines.push({
                  radius: 60,
                  width: 2,
                  source: '河南省',
                  target: item.provinceName,
                })
              }
            }
          })
          this.mapConfig = {
            bgImgSrc: '/static/img/layout/map-China.png',
            points: points,
            lines: lines,
            icon: {
              show: true,
              src: '/static/img/layout/mapPoint.png',
            },
            text: {
              show: true,
            },
          }
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
  },
  created () {
    this.getDeployMapData()
  },
}
</script>

<style lang="less" scoped>
  .mapContent{
    width: 717px;
    height: 100%;
    position: relative;
    .ChinaMap {
      width: 717px;
      height: 712px;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
</style>
